import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

// Admin-only guard + fetch for the leads dashboard. Redirects non-admins away.
export const useAdminLeads = () => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [leads, setLeads] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate('/', { replace: true }); return; }
    if (user.role !== 'admin') { navigate('/account', { replace: true }); return; }
    fetch(`${API}/api/leads?limit=200`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('Failed to load'))))
      .then(setLeads)
      .catch(() => setError('Could not load leads.'));
  }, [user, loading, navigate]);

  const signOut = () => { logout(); navigate('/'); };
  return { leads, error, pending: loading || (!leads && !error), signOut };
};
